import React from 'react';
import { useFormikContext } from 'formik';
import styled from 'styled-components';
import { Text, Mixins, Button } from '@openfin/ui-library';

import { NftButtonOptions } from './CardButtonContainer';
import { useTooltip } from '../../hooks/useTooltip';

interface CardButtonProps extends NftButtonOptions {
  onMouseDown?: () => void;
  className?: string;
}

/**
 * A single NotificationCard button.
 */
export const CardButton: React.FC<CardButtonProps> = (props) => {
  const { onMouseDown, title, cta, submit, onClick } = props;
  const tooltipRef = useTooltip(title);
  const btnType = submit ? 'submit' : 'button';
  const kind = cta ? 'primary' : 'textOnly';
  const className = `${cta ? 'notification-button-cta' : 'notification-button'} ${
    props.className ?? ''
  }`;
  let disabled = false;

  let handleClick : ((event: React.MouseEvent) => void) | undefined = (event) => {
    onClick(event, props);
  };

  if (submit) {
    const formikData = useFormikContext();
    // Check if this button is within a form
    // if so check if the form is valid
    // then disable this button if the form is not valid
    if (!formikData) {
      disabled = true;
      handleClick = undefined;
    } else {
      disabled = !formikData.isValid;
      handleClick = formikData.submitForm;
    }
  }

  return (
    <NftButton
      type={btnType}
      disabled={disabled}
      cta={cta}
      size="small"
      className={className}
      kind={kind}
      onClick={handleClick}
      onMouseDown={onMouseDown}
    >
      <ButtonText ref={tooltipRef}>{title}</ButtonText>
    </NftButton>
  );
};

/**
 * Inner button text.
 */
export const ButtonText = styled(Text)`
  ${Mixins.textOverflow}
  display: inline;
  width: 100%;
  text-align: center;
`;

const NftButton = styled(Button)<{ cta?: boolean }>`
  min-width: 40px;
  max-width: max-content;
  flex: 1 ${({ cta }) => (cta ? 1 : 100)} 100px;
`;
